<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to=" __('actions.back_thing', {thing: __('general.overview')})" :href="$route('brands.product-import.overview')"/>

        </Toolbar>
        <Card>
            <errors :errors="errors" show-close/>

            <div class="card card-body">
                <select-product-data-import-type v-model="setupData.importType"/>

                <div class="rounded overflow-hidden mt-2 mb-2" style="background-color: #f5f4fd;">
                    <div class="p-5 m-5">
                        <setup-file-upload v-if="setupData.importType === 'file'"
                                           @canProceed="canProceedToMapping = true"
                                           @input="data => setupData.settings = data"
                                           @file="selectedFile => setupData.flatFile = selectedFile"/>

                        <setup-url-upload v-else-if="setupData.importType === 'url'"
                                          @canProceed="b => canProceedToMapping = b"
                                          @input="data => setupData.settings = data"/>

                        <!--                <setup-ftp-connection v-else-if="selectedImportType === 'ftp'"-->
                        <!--                                      @canProceed="canProceedToMapping = true"-->
                        <!--                                      @input="data => settings = data"/>-->

                        <!--                <setup-api-connection v-else-->
                        <!--                                      @canProceed="canProceedToMapping = true"-->
                        <!--                                      @input="data => settings = data"/>-->
                    </div>
                </div>

                <div v-if="false" class="mt-3 mb-3 border rounded p-5">
                    <pre>{{ setupData.settings }}</pre>
                </div>

                <div class="mt-4">
                    <button class="btn btn-primary" @click="submit">
                        Weiter zur Feldzuweisung
                        <i v-if="!loading" class="fas fa-arrow-circle-right ml-2"/>
                        <spinner v-else class="d-inline-block ml-2 mb-n1" :size="18" line-fg-color="#fff"/>
                    </button>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import SelectProductDataImportType from '@components/MegaOptions/SelectProductDataImportType'
import SetupFileUpload from '@components/Brand/ProductImport/SetupFileUpload'
import SetupUrlUpload from '@components/Brand/ProductImport/SetupUrlUpload'
import SetupFtpConnection from '@components/Brand/ProductImport/SetupFtpConnection'
import SetupApiConnection from '@components/Brand/ProductImport/SetupApiConnection'
import Spinner from 'vue-simple-spinner'
import CsrfToken from '@components/CsrfToken'
import Errors from '@components/Errors'
import Card from '@components/Cards/Card.vue'
import Toolbar from '@components/Toolbar.vue'
import BackButton from '@components/BackButton.vue'
import {rewriteUrlNew} from '@composables/rewriteUrlNew'

export default {
    components: {
        BackButton, Toolbar,
        Card,
        SelectProductDataImportType,
        SetupFileUpload,
        SetupFtpConnection,
        SetupApiConnection,
        SetupUrlUpload,
        Spinner,
        CsrfToken,
        Errors,
    },

    props: {
        srcType: String,
        firebaseUid: String,
    },

    data() {
        return {
            loading: false,
            canProceedToMapping: false,
            errors: {},
            setupData: this.$inertia.form({
                importType: 'file',
                flatFile: null,
                settings: {},
            })
        }
    },

    mounted() {
        if (this.srcType) {
            this.setupData.importType = this.srcType
        }

        window.Echo.private('users.' + this.firebaseUid).
            listen('.brand-product-import-setup.post', (data) => {
                if (data.success) {
                    this.$inertia.visit(this.$route('brands.product-import.mapping', {sourceId: data.id}));
                }
            })
    },

    methods: {
        submit() {
            this.errors = {}
            this.loading = true

            this.setupData.post(this.$route('brands.product-import.setup.post'), {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onError: () => {
                    toastr.error(__('general.error_check_data'))
                    //this.errors = error.response.data.errors

                    this.loading = false
                },
            });
        },
    },

    watch: {
        'setupData.importType'() {
            this.settings = {}
            rewriteUrlNew('src', this.setupData.importType)
        },
    },
}
</script>
